import contactPlannerWidgetMigrations from './contactPlannerWidget';

/**
* Migrations for an individual "layoutItem" object of the event site editor website.
* These are event specific migrations to apply to existing websites so that
* event website specific breaking changes can be compatible with them.
*/
export default function layoutItemMigrations(layoutItem) {
  if (layoutItem.layout.type !== 'widget') {
    return layoutItem;
  }
  switch (layoutItem.widgetType) {
    case 'ContactPlanner':
      return contactPlannerWidgetMigrations(layoutItem);
    default:
      return layoutItem;
  }
}
